import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SchemaOrg from '../../components/feature/SchemaOrg';

export default function AProposPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SchemaOrg type="about" />
      <div className="min-h-screen bg-white">
        <Navbar />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-red-600 to-red-700 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
            <div className="text-center max-w-3xl mx-auto">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6 backdrop-blur-sm">
                <i className="ri-team-line text-4xl text-white"></i>
              </div>
              <h1 className="text-5xl md:text-6xl font-black text-white mb-6 leading-tight">
                À propos de nous
              </h1>
              <p className="text-xl text-white/90 leading-relaxed">
                Votre partenaire de confiance pour tous vos besoins de transport en Île-de-France
              </p>
            </div>
          </div>
        </section>

        {/* Notre Histoire */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                  <i className="ri-history-line"></i>
                  Notre histoire
                </div>
                <h2 className="text-4xl font-black text-gray-900 mb-6">
                  Transporteur Express IDF, votre expert en transport depuis 2015
                </h2>
                <p className="text-gray-600 text-lg leading-relaxed mb-4">
                  Fondée en 2015, <strong>Transporteur Express IDF</strong> est née d'une vision simple : offrir un service de transport rapide, fiable et accessible à tous les professionnels et particuliers d'Île-de-France.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed mb-4">
                  Depuis nos débuts, nous avons effectué plus de <strong>50 000 livraisons</strong> dans toute la région parisienne, du simple colis urgent au déménagement complet, en passant par le transport de palettes et la location de véhicules avec chauffeur.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed">
                  Notre engagement : être disponibles <strong>24h/24 et 7j/7</strong> pour répondre à tous vos besoins de transport, même les plus urgents.
                </p>
              </div>
              <div className="relative">
                <img
                  src="https://public.readdy.ai/ai/img_res/7c6142cb6deefe7c89bde5ce1c3437fd.jpg"
                  alt="Équipe Transporteur Express IDF"
                  className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
                />
                <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                      <i className="ri-trophy-line text-2xl text-red-600"></i>
                    </div>
                    <div>
                      <p className="text-3xl font-black text-gray-900">50 000+</p>
                      <p className="text-sm text-gray-600 font-medium">Livraisons réussies</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Nos Valeurs */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-heart-line"></i>
                Nos valeurs
              </div>
              <h2 className="text-4xl font-black text-gray-900 mb-4">
                Ce qui nous guide au quotidien
              </h2>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                Des principes forts qui définissent notre approche du service
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-time-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Rapidité</h3>
                <p className="text-gray-600 leading-relaxed">
                  Livraison express en moins d'1 heure dans Paris. Votre temps est précieux, nous le respectons.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Fiabilité</h3>
                <p className="text-gray-600 leading-relaxed">
                  99,8% de livraisons réussies. Vos colis arrivent à destination en parfait état, à l'heure prévue.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-customer-service-2-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Service client</h3>
                <p className="text-gray-600 leading-relaxed">
                  Une équipe à votre écoute 24h/24. Réponse immédiate à toutes vos questions et demandes.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-price-tag-3-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Transparence</h3>
                <p className="text-gray-600 leading-relaxed">
                  Tarifs clairs sans frais cachés. Devis gratuit et estimation de prix en ligne instantanée.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Zone de Couverture */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <img
                  src="https://readdy.ai/api/search-image?query=Detailed%20map%20of%20Paris%20and%20Ile-de-France%20region%20with%20red%20delivery%20route%20markers%2C%20modern%20digital%20map%20interface%2C%20GPS%20tracking%20visualization%2C%20clean%20professional%20design%2C%20bright%20colors%2C%20technology%20concept&width=600&height=500&seq=about-map-001&orientation=landscape"
                  alt="Zone de couverture Île-de-France"
                  className="w-full h-[400px] object-cover object-top rounded-2xl shadow-2xl"
                />
              </div>
              <div className="order-1 lg:order-2">
                <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                  <i className="ri-map-pin-line"></i>
                  Notre zone de couverture
                </div>
                <h2 className="text-4xl font-black text-gray-900 mb-6">
                  Toute l'Île-de-France à votre service
                </h2>
                <p className="text-gray-600 text-lg leading-relaxed mb-6">
                  Nous intervenons dans l'ensemble de la région Île-de-France, avec une expertise particulière sur les zones suivantes :
                </p>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center shrink-0 mt-1">
                      <i className="ri-check-line text-sm text-red-600"></i>
                    </div>
                    <div>
                      <p className="font-bold text-gray-900">Paris (75) — Tous arrondissements</p>
                      <p className="text-gray-600 text-sm">Livraison express en moins d'1 heure</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center shrink-0 mt-1">
                      <i className="ri-check-line text-sm text-red-600"></i>
                    </div>
                    <div>
                      <p className="font-bold text-gray-900">Hauts-de-Seine (92) — Nanterre, Courbevoie, Levallois...</p>
                      <p className="text-gray-600 text-sm">Service prioritaire pour les entreprises</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center shrink-0 mt-1">
                      <i className="ri-check-line text-sm text-red-600"></i>
                    </div>
                    <div>
                      <p className="font-bold text-gray-900">Seine-Saint-Denis (93) — Villepinte, Saint-Denis...</p>
                      <p className="text-gray-600 text-sm">Spécialiste événementiel et salons professionnels</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center shrink-0 mt-1">
                      <i className="ri-check-line text-sm text-red-600"></i>
                    </div>
                    <div>
                      <p className="font-bold text-gray-900">Val-de-Marne (94) — Rungis, Créteil, Ivry...</p>
                      <p className="text-gray-600 text-sm">Transport de palettes et marchandises lourdes</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center shrink-0 mt-1">
                      <i className="ri-check-line text-sm text-red-600"></i>
                    </div>
                    <div>
                      <p className="font-bold text-gray-900">Toute l'Île-de-France (77, 78, 91, 95)</p>
                      <p className="text-gray-600 text-sm">Livraison dans toute la région parisienne</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Nos Engagements */}
        <section className="py-20 bg-gradient-to-br from-red-600 to-red-700">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-2 bg-white/20 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6 backdrop-blur-sm">
                <i className="ri-hand-heart-line"></i>
                Nos engagements
              </div>
              <h2 className="text-4xl font-black text-white mb-4">
                Notre promesse qualité
              </h2>
              <p className="text-white/90 text-lg max-w-2xl mx-auto">
                Des garanties concrètes pour votre tranquillité d'esprit
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
                <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-24-hours-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">Disponibilité 24h/24</h3>
                <p className="text-white/80 leading-relaxed">
                  Service d'urgence disponible tous les jours, même les week-ends et jours fériés. Nous sommes là quand vous avez besoin de nous.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
                <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">Assurance complète</h3>
                <p className="text-white/80 leading-relaxed">
                  Tous nos transports sont assurés. Vos biens sont protégés du départ à l'arrivée, pour une sérénité totale.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
                <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-leaf-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">Démarche éco-responsable</h3>
                <p className="text-white/80 leading-relaxed">
                  Flotte de véhicules récents aux normes Euro 6. Optimisation des trajets pour réduire notre empreinte carbone.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Chiffres Clés */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-bar-chart-line"></i>
                Nos chiffres clés
              </div>
              <h2 className="text-4xl font-black text-gray-900 mb-4">
                Transporteur Express IDF en chiffres
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-5xl font-black text-red-600 mb-2">50 000+</div>
                <p className="text-gray-600 font-semibold">Livraisons effectuées</p>
              </div>
              <div className="text-center">
                <div className="text-5xl font-black text-red-600 mb-2">99,8%</div>
                <p className="text-gray-600 font-semibold">Taux de satisfaction</p>
              </div>
              <div className="text-center">
                <div className="text-5xl font-black text-red-600 mb-2">24/7</div>
                <p className="text-gray-600 font-semibold">Disponibilité</p>
              </div>
              <div className="text-center">
                <div className="text-5xl font-black text-red-600 mb-2">&lt;1h</div>
                <p className="text-gray-600 font-semibold">Délai moyen Paris</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-black text-gray-900 mb-6">
              Prêt à travailler avec nous ?
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Contactez-nous dès maintenant pour obtenir un devis gratuit ou réserver votre transport
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+33632410246"
                className="inline-flex items-center justify-center gap-2 bg-red-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-red-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                +33 6 32 41 02 46
              </a>
              <a
                href="https://wa.me/33632410246"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-green-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-green-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}